import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { notificationsCountReducer } from './+store/notifications-count.reducer';
import { NOTIFICATIONS_COUNT_FEATURE_KEY } from './+store/notifications-count.state';
import { NotificationsDrawerLazyEffects } from './+store/notifications-drawer.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(NOTIFICATIONS_COUNT_FEATURE_KEY, notificationsCountReducer),
    EffectsModule.forFeature([NotificationsDrawerLazyEffects])
  ]
})
export class NotificationsDrawerLazyModule {}
